import {TranslationObject} from '@colonist/i18n'
import {ActionStatus} from '@colonist/game-base-types'
import * as tradeStateTypes from '@colonist/game-states'
import {PlayerColor, TradeId} from '@colonist/game-states'

export interface TradeError {
    error: TranslationObject
    payload?: TradeErrorPayload
}

export interface TradeErrorPayload {
    highlightCards?: {
        cardsToHighlight: tradeStateTypes.CardEnum[]
        locations: TradeErrorHighlightLocationEnum[]
    }
    highlightTrade?: {
        tradeIds: TradeId[]
        autoAcceptOffer?: boolean
    }
    isPlayerTradeButtonDisabled?: boolean
    isBankTradeButtonDisabled?: boolean
}

export enum TradeErrorHighlightLocationEnum {
    ProposalWanted,
    ProposalOffered,
    WantedSelector,
    OfferedSelector
}

/**
 * @deprecated Import TradeResponseStatus from @colonist/game-states
 */
export import TradeResponseStatus = tradeStateTypes.TradeResponseStatus

export enum TradeActions {
    Accept,
    Reject,
    CounterOfferCreating,
    CounterOfferCreatedOrCanceled
}

export interface TradeCreationData {
    readonly creator: PlayerColor
    readonly isBankTrade: boolean
    readonly counterOfferInResponseToTradeId: TradeId | undefined
    readonly offeredResources: tradeStateTypes.CardEnum[]
    readonly wantedResources: tradeStateTypes.CardEnum[]
    readonly forcedResponse?: TradeResponseStatus
}

export interface TradeResponse {
    readonly id: TradeId
    readonly response: TradeActions
}

export interface TradeExecutionData {
    readonly tradeId: TradeId
    readonly playerToExecuteTradeWith: PlayerColor
}

export interface TradeActionStatus extends ActionStatus {
    displayActionButton: boolean
}

export interface TradePlayerResponseStatus {
    readonly player: PlayerColor
    responseStatus: TradeResponseStatus
}

export interface TradePlayerCreatingCounterOfferStatus {
    readonly player: PlayerColor
    isCreatingCounterOffer: boolean
}

// Feb 17, 2021. Jeff: I didn't refactor this out yet. Please don't use.
export interface GiveWantTradeFormat {
    givingResources: tradeStateTypes.CardEnum[]
    wantResources: tradeStateTypes.CardEnum[]
    target: PlayerColor
}

export enum TradeOfferOpponentDisplay {
    AvatarContainer,
    ResponseButtons,
}

